// Core inside the Android app (CherryPickApp): the app adds `window.CoreNative`
// (records the screen + the front camera in a corner + the microphone, uploads
// the video to the assessment itself) and sends events as
// window 'corenative' CustomEvents: { type, status, elapsed, progress, error, asset }.

export const inNativeApp = () =>
  typeof window !== 'undefined' &&
  !!window.CoreNative &&
  typeof window.CoreNative.start === 'function';

export function nativeCall(name, arg) {
  try {
    const fn = window.CoreNative && window.CoreNative[name];
    if (typeof fn !== 'function') return null;
    return arg === undefined
      ? fn.call(window.CoreNative)
      : fn.call(
          window.CoreNative,
          typeof arg === 'string' ? arg : JSON.stringify(arg)
        );
  } catch (e) {
    return null;
  }
}

export function onNative(fn) {
  const h = (e) => fn(e.detail || {});
  window.addEventListener('corenative', h);
  return () => window.removeEventListener('corenative', h);
}

export function nativeState() {
  try {
    return JSON.parse(nativeCall('state') || '{}');
  } catch (e) {
    return {};
  }
}
